import type { IconProps } from '@tabler/icons-react'
import type { ForwardRefExoticComponent, RefAttributes } from 'react'
import { forwardRef } from 'react'

export const SidekickDeeplinkIcon: ForwardRefExoticComponent<IconProps & RefAttributes<SVGSVGElement>> = forwardRef<
  SVGSVGElement,
  IconProps
>(({ size = 24, stroke = 1.5, className, ...props }, ref) => (
  <svg
    ref={ref}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="2 2 20 20"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeWidth={stroke}
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    {...props}>
    <path d="M12,4.01c-4.41,0-7.99,3.58-7.99,7.99s3.58,7.99,7.99,7.99,7.99-3.58,7.99-7.99-3.58-7.99-7.99-7.99ZM14.74,9.17l-1.32,5.94c-.05.23-.35.29-.49.1l-1.7-2.46s-.08-.08-.14-.1l-2.65-.9c-.24-.08-.25-.41-.01-.51l5.94-2.38c.2-.08.41.1.37.31Z" />
  </svg>
))

SidekickDeeplinkIcon.displayName = 'SidekickDeeplinkIcon'
